import { AppState } from "../state/app.state";
import { createSelector } from '@ngrx/store';
import { VideoFrame } from 'src/app/models/video_frame';
import UploadedFile from 'src/app/models/uploaded_file';
import { VideosSelectors, FramesSelectors } from './collection.selectors';

const getSelectedFrameIds = (state: AppState) => state.contentsTabComponent.selectedFrames;
const getSelectedVideoIds = (state: AppState) => state.contentsTabComponent.selectedVideos;
const getSelectedTabNumber = (state: AppState) => state.contentsTabComponent.selectedTabNumber;
const getPageFrameIds = (state: AppState) => state.contentsTabComponent.pageFrameIds;
const getFramePageNumber = (state: AppState) => state.contentsTabComponent.framesPage;
const getTotalFramePages = (state: AppState) => state.contentsTabComponent.totalFramePages;
const getFramesFilters = (state: AppState) => state.contentsTabComponent.framesFilters;
const getFrameFiltersShown = (state: AppState) => state.contentsTabComponent.frameFiltersShown;

const getPageVideoIds = (state: AppState) => state.contentsTabComponent.pageVideoIds;
const getVideoPageNumber = (state: AppState) => state.contentsTabComponent.videosPage;
const getTotalVideoPages = (state: AppState) => state.contentsTabComponent.totalVideoPages;
const getVideoFilters = (state: AppState) => state.contentsTabComponent.videoFilters;
const getVideoFiltersShown = (state: AppState) => state.contentsTabComponent.videoFiltersShown;

export const selectSelectedFrames = createSelector(
  FramesSelectors.selectItems,
  getSelectedFrameIds,
  (frames: VideoFrame[], frameIds: number[]) =>
    frames == null || frames.length === 0
    ? []
    : frames.filter(frame => frameIds.includes(frame.id))
)

export const selectSelectedVideos = createSelector(
  VideosSelectors.selectItems,
  getSelectedVideoIds,
  (videos: UploadedFile[], videoIds: number[]) =>
    videos == null || videos.length === 0
    ? []
    : videos.filter(video => videoIds.includes(video.id))
)

export const selectFramesOfSelectedVideos = createSelector(
  selectSelectedVideos,
  FramesSelectors.selectItems,
  getSelectedVideoIds,
  (videos: UploadedFile[], frames: VideoFrame[], videoIds: number[]) => {
    const selectedVideoIds = videos.map(v => v.id); // Frames are still referencing videos by server ids.
    return frames.filter(f => selectedVideoIds.indexOf(f.video_id) >= 0);
  }
)

export const selectSelectedTabNumber = createSelector(
  getSelectedTabNumber,
  (tabNumber : number) => tabNumber
)

export const selectFramesPageNumber = createSelector(
  getFramePageNumber,
  (num) => {
    return num;
  }
) 

export const selectPageFrames = createSelector(
  getPageFrameIds,
  FramesSelectors.selectDict,
  (frameIDs, frames) => frameIDs.map(id => frames[id])
)

export const selectTotalFramePages = createSelector(
  getTotalFramePages,
  (total) => total
)

export const selectCurrentFrameFilters = createSelector(
  getFramesFilters,
  (filters) => filters 
)

export const selectIsFrameFiltersShown = createSelector(
  getFrameFiltersShown,
  (filters) => filters 
)

export const selectVideoPageNumber = createSelector(
  getVideoPageNumber,
  (num) => {
    return num;
  }
) 

export const selectPageVideo = createSelector(
  getPageVideoIds,
  VideosSelectors.selectDict,
  (videoIDs, video) => videoIDs.map(id => video[id])
)

export const selectTotalVideoPages = createSelector(
  getTotalVideoPages,
  (total) => total
)

export const selectCurrentVideoFilters = createSelector(
  getVideoFilters,
  (filters) => filters 
)

export const selectIsVideoFiltersShown = createSelector(
  getVideoFiltersShown,
  (filters) => filters 
)